<div>
  <div class="tw-w-full tw-flex-end">
    <button
      (click)="addNewNode(null, false)"
      class="hover:tw-bg-teal-700 tw-mx-1 tw-bg-teal-600 tw-cursor-pointer tw-px-5 tw-py-2 tw-rounded-md tw-text-white"
    >
      <span class="tw-font-medium tw-text-lg tw-px-1">{{
        "common.new" | translate
      }}</span>
      <i class="mdi mdi-plus mdi-22px tw-text-white"></i>
    </button>
  </div>
  <div class="tw-relative">
    <!-- btns -->
    <div class="tw-flex-center tw-absolute tw-top-4 tw-right-4 tw-z-10">
      <!-- ZoomToFit btn -->
      <button
        [matTooltip]="'common.zoomToFit' | translate"
        (click)="setZoomToFit()"
        class="hover:tw-bg-gray-400 dark:tw-bg-dark-100 hover:dark:tw-bg-dark-500 tw-bg-gray-300 tw-cursor-pointer tw-h-12 tw-mx-1 tw-p-3 tw-rounded-full tw-w-12"
      >
        <i
          class="mdi mdi-fit-to-screen-outline tw-text-gray-700 dark:tw-text-white mdi-20px"
        ></i>
      </button>

      <!-- Zoom In btn -->
      <button
        [matTooltip]="'common.zoomIn' | translate"
        (click)="increaseZoom()"
        class="hover:tw-bg-gray-400 dark:tw-bg-dark-100 hover:dark:tw-bg-dark-500 tw-bg-gray-300 tw-cursor-pointer tw-h-12 tw-mx-1 tw-p-3 tw-rounded-full tw-w-12"
      >
        <i
          class="mdi mdi-magnify-plus-outline tw-text-gray-700 dark:tw-text-white mdi-20px"
        ></i>
      </button>

      <!-- Zoom Out btn -->
      <button
        [matTooltip]="'common.zoomOut' | translate"
        (click)="decreaseZoom()"
        class="hover:tw-bg-gray-400 dark:tw-bg-dark-100 hover:dark:tw-bg-dark-500 tw-bg-gray-300 tw-cursor-pointer tw-h-12 tw-mx-1 tw-p-3 tw-rounded-full tw-w-12"
      >
        <i
          class="mdi mdi-magnify-minus-outline tw-text-gray-700 dark:tw-text-white mdi-20px"
        ></i>
      </button>

      <!-- Reload btn -->
      <button
        [matTooltip]="'common.reload' | translate"
        (click)="reload()"
        class="hover:tw-bg-gray-400 dark:tw-bg-dark-100 hover:dark:tw-bg-dark-500 tw-bg-gray-300 tw-cursor-pointer tw-h-12 tw-mx-1 tw-p-3 tw-rounded-full tw-w-12"
      >
        <i
          class="mdi mdi-refresh tw-text-gray-700 dark:tw-text-white mdi-20px"
        ></i>
      </button>

      <!-- Redo btn -->
      <!-- <button
        matTooltip="Redo"
        (click)="redoDiagramChanges()"
        class="hover:tw-bg-gray-400 dark:tw-bg-dark-100 hover:dark:tw-bg-dark-500 tw-bg-gray-300 tw-cursor-pointer tw-h-12 tw-mx-1 tw-p-3 tw-rounded-full tw-w-12"
      >
        <i
          class="mdi mdi-redo tw-text-gray-700 dark:tw-text-white mdi-20px"
        ></i>
      </button> -->

      <!-- Undo btn -->
      <!-- <button
        matTooltip="Undo"
        (click)="undoDiagramChanges()"
        class="hover:tw-bg-gray-400 dark:tw-bg-dark-100 hover:dark:tw-bg-dark-500 tw-bg-gray-300 tw-cursor-pointer tw-h-12 tw-mx-1 tw-p-3 tw-rounded-full tw-w-12"
      >
        <i
          class="mdi mdi-undo tw-text-gray-700 dark:tw-text-white mdi-20px"
        ></i>
      </button> -->
    </div>

    <!-- diagram -->
    <div
      [id]="diagramId"
      class="tw-h-[625px] tw-rounded-md tw-mt-3 *:!tw-overflow-hidden"
    ></div>
  </div>
</div>
